import StringHelper from 'utilities/stringHelper';
import { TRANSFER_CERTIFICATE, VIDEO_SELFIE } from 'constants/identityMethod';
import { IDENTITY_DOCUMENTS, EXTRA_DOCUMENTS } from 'constants/documents';

export const transferDocuments = ['transfer_certificate', 'recibo'];
export const allDocuments = [...IDENTITY_DOCUMENTS, ...EXTRA_DOCUMENTS];

export const getDocsThatMatchsWith = (documentsCompleted = [], documentsToMatch) => {
    const isMatch = documentsCompleted.reduce((acum, iteration) => {
        documentsToMatch.some(doc => {
            if (iteration.docId === doc) return acum.push({ doc });
        });

        return acum;
    }, []);

    return isMatch.length > 0;
};

export const checkDocumentationCompleted = documentation => {
    const isMatchAnyIdDocuments = getDocsThatMatchsWith(documentation, IDENTITY_DOCUMENTS);
    const isMatchAnyExtraDocuments = getDocsThatMatchsWith(documentation, EXTRA_DOCUMENTS);
    const isMatchAnyDocuments = getDocsThatMatchsWith(documentation, allDocuments);
    const isMatchTransferCertificate = getDocsThatMatchsWith(documentation, transferDocuments);

    return {
        isMatchAnyIdDocuments,
        isMatchAnyExtraDocuments,
        isMatchAnyDocuments,
        isMatchTransferCertificate,
    };
};

export const createCardsMessagesWith = (method, documentation) => {
    const { isMatchAnyIdDocuments, isMatchAnyExtraDocuments, isMatchAnyDocuments, isMatchTransferCertificate } =
        checkDocumentationCompleted(documentation);

    const identificationMethod = StringHelper.capitalize(`${method}`);

    const transferAndExtraDocs = isMatchTransferCertificate && isMatchAnyExtraDocuments;
    const transferAndIdDocs = isMatchTransferCertificate && isMatchAnyIdDocuments;

    let identificationMethodTextKey;

    if (isMatchAnyDocuments)
        identificationMethodTextKey = `documentation-identificationCard${identificationMethod}AndDoc`;
    switch (method) {
        case TRANSFER_CERTIFICATE:
            if (transferAndExtraDocs)
                identificationMethodTextKey = `documentation-identificationCardTransferReceiptAndDoc`;
            else if (transferAndIdDocs) identificationMethodTextKey = `documentation-identificationCardTransfer`;
            break;
        case VIDEO_SELFIE:
            if (isMatchAnyDocuments) identificationMethodTextKey = `documentation-identificationCardVideoSelfieAndDoc`;
            else identificationMethodTextKey = `documentation-identificationCardVideoSelfie`;
            break;
        default:
            method
                ? (identificationMethodTextKey = `documentation-identificationCard${identificationMethod}`)
                : (identificationMethodTextKey = `documentation-identificationCardTransfer`);
            break;
    }

    return {
        isMatchAnyIdDocuments,
        isMatchAnyExtraDocuments,
        isMatchTransferCertificate,
        identificationMethodTextKey,
    };
};
